import { EHeadingStyleVariant, ETextStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import React from 'react';

type THeadlineProps = {
  headline: React.ReactNode | string;
  subheadline: React.ReactNode | string;
};

export const Headline = ({ headline, subheadline }: THeadlineProps) => {
  return (
    <div className="mb-5">
      <Text
        variant={ETextStyleVariant.Label}
        className="pt-5 tracking-wider md:text-[16px] md:pt-10">
        {subheadline}
      </Text>
      <Heading
        variant={EHeadingStyleVariant.H1Alt}
        className="flex mt-0 not-italic font-normal break-words text-[32px] md:text-[72px] leading-10 md:leading-none md:mt-2">
        {headline}
      </Heading>
    </div>
  );
};
